export var getPaymentDetails = function (data, path) {
    if (path === void 0) { path = 'payment-details'; }
    var url = new window.Url();
    return window.fetcher
        .post(url.build('payments', path), data)
        .then(function (response) {
        return response.data;
    })
        .catch(function (error) {
        if (error.status === 455) {
            url.redirectTo('meal-plan-error');
        }
        else if (error.status === 404) {
            url.redirectTo('/');
        }
        else {
            window.payments.formError.display(data.payment_provider, error.responseJSON.message);
            window.payments.payButton.enable();
            window.payments.applePayButtons.enable();
            window.payments.btnLoader.hide(data.payment_provider);
            window.payments.paymentFormCloseButton.show();
        }
    });
};
